<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :rowButtonAction="rowButtonAction"
                :buttonsVisibility="buttonsVisibility"
                :tooltipColumns="tooltipColumns"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <OfferForm :formProps="formProps"> </OfferForm>
            </template>
            <template #search="searchProps">
                <OfferSearch :searchProps="searchProps"> </OfferSearch>
            </template>
            <template #buttons="formProps">
                <div style="display: flex; align-items: center; gap: 12px; width: auto; max-width: fit-content;">
                    <Button @click="showGetDataForm(formProps)"
                            style="background-color: royalblue; font-weight: normal;">
                        <i class="fa-solid fa-box-open"
                           style="margin-right:5px;font-size:18px"></i>
                        {{ __('Get data from makretplaces') }}
                    </Button>
                    <FormSelect fieldName="marketplace_code"
                                label=""
                                showClear
                                style="width: 220px;"
                                :change="() => setMarketplaceCodeFilter(formProps)"
                                :filtering="false"
                                :isFormDisabled="false"
                                :options="select?.api_marketplaces"
                                v-model:field="marketplaceCode" />
                    <Button v-if="marketplaceCode"
                            @click="() => openUpdatePriceModal(formProps)"
                            id="filter-button"
                            style="background-color: white; color: brown; font-weight: normal;"
                            severity="info">
                        <i class="fa-solid fa-filter-circle-dollar"
                           style="margin-right:5px;font-size:18px;color:brown;"></i>
                        {{ __('Set price') }}
                    </Button>
                </div>
            </template>
        </v-view>

        <Dialog modal
                :visible="getDataModalOpen"
                v-model:visible="getDataModalOpen"
                :header="__('Getting data from marketplaces')"
                :style="{ width: '500px' }">
            <GetDataForm :formProps="propsFromView"
                         v-model:getDataModalOpen="getDataModalOpen">
            </GetDataForm>
        </Dialog>

        <Dialog modal
                :visible="isUpdatePriceModalOpen"
                v-model:visible="isUpdatePriceModalOpen"
                :header="__('Update price')"
                :style="{ width: '500px' }">
            <UpdatePriceForm :formProps="updatePriceFormProps"
                             v-model:isUpdatePriceModalOpen="isUpdatePriceModalOpen">
            </UpdatePriceForm>
        </Dialog>

    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import OfferForm from "./OfferForm.vue";
import OfferSearch from "./OfferSearch.vue";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import GetDataForm from "./GetDataForm.vue";
import UpdatePriceForm from "./UpdatePriceForm.vue";
import FormSelect from "@crud/FormSelect.vue";

import { prepareSelect, rowButtonAction } from '@pages/Helper/crud_utils.js'
import { __, checkSelectedAndOpenModal, getSessionValue, setSessionValue } from "@pages/Helper/utils.js";
import { getFromRoute } from "../../../Helper/utils";

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    tooltipColumns: Object,
    initialSort: Object,
    buttonsVisibility: Object,
});

const getDataModalOpen = ref(false);
const selectedRows = ref([]);
const propsFromView = ref({});

const isLoading = ref(false);
const options = ['api_marketplaces']
const select = ref(null)
const marketplaceCode = ref(null)
const isUpdatePriceModalOpen = ref(false)
const updatePriceFormProps = ref({})


//------------------------------------------------------------------------------

onMounted(async () => {
    select.value = await prepareSelect(options)
    marketplaceCode.value = getSessionValue('marketplace-code-filter')
})

//------------------------------------------------------------------------------

const showGetDataForm = (formProps) => {
    propsFromView.value = formProps;
    getDataModalOpen.value = true;
};

//------------------------------------------------------------------------------

const setMarketplaceCodeFilter = async (formProps) => {
    isLoading.value = true;
    await getFromRoute('offer-marketplace-filter', { 'marketplace_code': marketplaceCode.value })

    formProps.clearSelection()
    formProps.getLazyData()
    isLoading.value = false;
}

//------------------------------------------------------------------------------

const openUpdatePriceModal = (formProps) => {
    checkSelectedAndOpenModal({ ...formProps, marketplace_code: marketplaceCode.value }, updatePriceFormProps, isUpdatePriceModalOpen)
}

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
